/**
 * @Author:
 * @Description:
 * @DateTime: Created in 17:28 2020/10/16
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import _ from 'lodash';
import { createBEM, createNamespace } from 'src/util/bem';
import './deviceControl.less';
import AgGridVueCustomTsx, { ColDefCustom } from 'src/components/agGridCustom/agGridVueCustomTsx';
import { GridOptions } from 'ag-grid-community';
import CellRenderTsx from 'src/components/agGridComponent/cellRenderTsx';
import alertControlModal, { ControlVOI } from './controlModal';
import DatePicker from 'src/types/iview/DatePicker';
import Bus, { Events } from 'src/util/bus';
import { StationListDOI } from 'src/pages/stationList/api/stationListApi';
import Button from 'src/types/iview/Button';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
// import InputNumber from 'src/types/iview/InputNumber';
import UnitGroupApi from 'src/pages/systemConfig/unitConfig/api/unitGroupApi';
import DeviceControlApi, { DeviceControlDOI } from './api/deviceControlApi';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import alertControlRecordModal from './controlRecordModal';
let bem = createBEM('device-control');
export namespace DeviceControlVOI{
    export interface RowI {
        operateName: string;
        operateCode: string;
        operateUrl: string;
        operateTime: string;
        result: string;
        operateMan: string;
        inputItems?:ControlVOI.InputItemsI[]
    }
}

@Component
export default class DeviceControl extends Vue.Component<any> {
    mn: string = '';
    gridOptionsSystem: GridOptions = {};
    rowDataSystem: DeviceControlVOI.RowI[] = [
        {
            operateName: '设置系统时间',
            operateCode: 'CN1015',
            operateUrl: '/countercharge/ipc_time/calibration',
            operateTime: '',
            result: '',
            operateMan: '',
            inputItems: [{
                component: DatePicker,
				label: '时间',
                field: 'systemtime',
                dataType: 'date',
                props: {value: '', type: 'datetime', format: 'yyyy-MM-dd HH:mm:ss',placeholder: '请选择时间', clearable: false, confirm: false},
            }]
        },
        {
            operateName: '提取核查数据',
            operateCode: 'CN2062',
            operateUrl: '/countercharge/check_the_data/extract',
            operateTime: '',
            result: '',
            operateMan: '',
            inputItems: [{
                component: DatePicker,
				label: '时间',
                field: 'time',
                realField: ['begintime','endtime'],
                dataType: 'array',
                props: {value: [], type: 'daterange', format: 'yyyy-MM-dd',placeholder: '请选择时间', clearable: false, },
            }]
        },
        {
            operateName: '提取加标回收数据',
            operateCode: 'CN2063',
            operateUrl: '/countercharge/label_recovery_data/extract',
            operateTime: '',
            result: '',
            operateMan: '',
            inputItems: [{
                component: DatePicker,
				label: '时间',
                field: 'time',
                realField: ['begintime','endtime'],
                dataType: 'array',
                props: {value: [], type: 'daterange', format: 'yyyy-MM-dd',placeholder: '请选择时间', clearable: false, },
            }]
        },
        {
            operateName: '提取平行样测试数据',
            operateCode: 'CN2064',
            operateUrl: '/countercharge/parallel_sample_test_data/extract',
            operateTime: '',
            result: '',
            operateMan: '',
            inputItems: [{
                component: DatePicker,
				label: '时间',
                field: 'time',
                realField: ['begintime','endtime'],
                dataType: 'array',
                props: {value: [], type: 'daterange', format: 'yyyy-MM-dd',placeholder: '请选择时间', clearable: false, },
            }]
        },{
            operateName: '提取零点核查数据',
            operateCode: 'CN2065',
            operateUrl: '/countercharge/national_standard_zero_check_data/extract',
            operateTime: '',
            result: '',
            operateMan: '',
            inputItems: [{
                component: DatePicker,
				label: '时间',
                field: 'time',
                realField: ['begintime','endtime'],
                dataType: 'array',
                props: {value: [], type: 'daterange', format: 'yyyy-MM-dd',placeholder: '请选择时间', clearable: false, },
            }]
        },{
            operateName: '提取跨度核查数据',
            operateCode: 'CN2066',
            operateUrl: '/countercharge/national_standard_span_check_data/extract',
            operateTime: '',
            result: '',
            operateMan: '',
            inputItems: [{
                component: DatePicker,
				label: '时间',
                field: 'time',
                realField: ['begintime','endtime'],
                dataType: 'array',
                props: {value: [], type: 'daterange', format: 'yyyy-MM-dd',placeholder: '请选择时间', clearable: false, },
            }]
        },
        {
            operateName: '提取实时数据',
            operateCode: 'CN2011',
            operateUrl: '/countercharge/real_time_data/extract',
            operateTime: '',
            result: '',
            operateMan: '',
            inputItems: [{
                component: DatePicker,
				label: '时间',
                field: 'time',
                realField: ['begintime','endtime'],
                dataType: 'array',
                props: {value: [], type: 'daterange', format: 'yyyy-MM-dd',placeholder: '请选择时间', clearable: false, },
            }]
        },{
            operateName: '提取测量数据',
            operateCode: 'CN2061',
            operateUrl: '/countercharge/data/addendum',
            operateTime: '',
            result: '',
            operateMan: '',
            inputItems: [{
                component: DatePicker,
				label: '时间',
                field: 'time',
                realField: ['begintime','endtime'],
                dataType: 'array',
                props: {value: [], type: 'daterange', format: 'yyyy-MM-dd',placeholder: '请选择时间', clearable: false, },
            }]
        },
        {
            operateName: '远程启动系统单次测试',
            operateCode: 'CN3044',
            operateUrl: '/countercharge/test/remote_boot',
            operateTime: '',
            result: '',
            operateMan: '',
        },
        {
            operateName: '远程切换运行模式',
            operateCode: 'CN3042',
            operateUrl: '/countercharge/cut_running_mode/remote_boot',
            operateTime: '',
            result: '',
            operateMan: '',
            inputItems: [{
                component: CommonSelect,
				label: '运行模式',
                field: 'runmode',
                dataType: 'number',
                props: {value: null,dataSource: [{id: 0, name: '维护模式'},{id: 1, name: '常规（定点）模式'},{id: 2, name: '应急（连续）模式'}],placeholder: '请选择', clearable: false, },
            }]
        },
        {
            operateName: '远程切换UPS状态',
            operateCode: 'CN3041',
            operateUrl: '/countercharge/ups_state/remote_boot',
            operateTime: '',
            result: '',
            operateMan: '',
            inputItems: [{
                component: CommonSelect,
				label: 'UPS状态',
                field: 'state',
                dataType: 'number',
                props: {value: null,dataSource: [{id: 0, name: '关闭'},{id: 1, name: '开启'}],placeholder: '请选择', clearable: false, },
            }]
        },
        {
            operateName: '停止系统测试',
            operateCode: 'CN3045',
            operateUrl: '/countercharge/system/stop',
            operateTime: '',
            result: '',
            operateMan: '',
        },
         // {
        //     operateName: '远程设置定点启动时间',
        //     operateCode: 'CN3090',
        //     operateUrl: '/countercharge/surface_water_fixed_point_start/remote_boot',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        // },
        // {
        //     operateName: '数据补遗',
        //     operateCode: 'CN2061',
        //     operateUrl: '/countercharge/data/addendum',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        //     inputItems: [{
        //         component: DatePicker,
		// 		label: '时间',
        //         field: 'time',
        //         realField: ['begintime','endtime'],
        //         dataType: 'array',
        //         props: {value: [], type: 'daterange', format: 'yyyy-MM-dd',placeholder: '请选择时间', clearable: false, },
        //     }]
        // },
    ];

    gridOptionsComponent: GridOptions = {};
    rowDataComponent: DeviceControlVOI.RowI[] = [
        {
            operateName: '远程启动单台仪表标样核查',
            operateCode: 'CN3080',
            operateUrl: '/countercharge/prototype_verification/remote_boot',
            operateTime: '',
            result: '',
            operateMan: '',
        },
        {
            operateName: '启动单台仪表零点核查',
            operateCode: 'CN3083',
            operateUrl: '/countercharge/periodic_calibration/remote_boot',
            operateTime: '',
            result: '',
            operateMan: '',
        },
        {
            operateName: '启动单台仪表跨度核查',
            operateCode: 'CN3084',
            operateUrl: '/countercharge/calibration_interval/setting',
            operateTime: '',
            result: '',
            operateMan: '',
        },
        {
            operateName: '远程启动单台仪表标1校准',
            operateCode: 'CN3085',
            operateUrl: '/countercharge/marking_a_calibration/remote_boot',
            operateTime: '',
            result: '',
            operateMan: '',
        },
        {
            operateName: '远程启动单台仪表标2校准',
            operateCode: 'CN3086',
            operateUrl: '/countercharge/the_second_calibration/remote_boot',
            operateTime: '',
            result: '',
            operateMan: '',
        },
        {
            operateName: '远程启动普通校准',
            operateCode: 'CN3011',
            operateUrl: '/countercharge/blank_calibration/factor_to_start',
            operateTime: '',
            result: '',
            operateMan: '',
        },
        {
            operateName: '远程启动清洗',
            operateCode: 'CN3013',
            operateUrl: '/countercharge/start/rinse',
            operateTime: '',
            result: '',
            operateMan: '',
        },
        {
            operateName: '远程启动做样',
            operateCode: 'CN3012',
            operateUrl: '/countercharge/start/sample',
            operateTime: '',
            result: '',
            operateMan: '',
        },
        {
            operateName: '远程启动标1测量',
            operateCode: 'CN3016',
            operateUrl: '/countercharge/start/one_measurement',
            operateTime: '',
            result: '',
            operateMan: '',
        },
        {
            operateName: '远程启动标2测量',
            operateCode: 'CN3017',
            operateUrl: '/countercharge/start/two_measurement',
            operateTime: '',
            result: '',
            operateMan: '',
        },
        {
            operateName: '读取校准曲线',
            operateCode: 'CN30210',
            operateUrl: '/countercharge/read/calibration_curve',
            operateTime: '',
            result: '',
            operateMan: '',
        },
        {
            operateName: '远程读取报警记录',
            operateCode: 'CN3020',
            operateUrl: '/countercharge/read/alarm_record',
            operateTime: '',
            result: '',
            operateMan: '',
            inputItems: [{
                component: DatePicker,
				label: '时间',
                field: 'time',
                realField: ['begintime','endtime'],
                dataType: 'array',
                props: {value: [], type: 'daterange', format: 'yyyy-MM-dd',placeholder: '请选择时间', clearable: false, },
            }]
        },
        {
            operateName: '远程读取运行日志',
            operateCode: 'CN30209',
            operateUrl: '/countercharge/read/running_log',
            operateTime: '',
            result: '',
            operateMan: '',
            inputItems: [{
                component: DatePicker,
				label: '时间',
                field: 'time',
                realField: ['begintime','endtime'],
                dataType: 'array',
                props: {value: [], type: 'daterange', format: 'yyyy-MM-dd',placeholder: '请选择时间', clearable: false, },
            }]
        },
         // {
        //     operateName: '启动单台仪表量程切换',
        //     operateCode: 'CN3091',
        //     operateUrl: '/countercharge/range_changing/remote_boot',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        //     inputItems: [{
        //         component: CommonSelect,
		// 		label: '量程',
        //         field: 'ranges',
        //         dataType: 'number',
        //         props: {value: null,dataSource: [{id: 1, name: '量程一'},{id: 2, name: '量程二'},{id: 3, name: '量程三'}],placeholder: '请选择', clearable: false, },
        //     }]
        // },
        // {
        //     operateName: '启动单台仪表平行样测试',
        //     operateCode: 'CN3082',
        //     operateUrl: '/countercharge/parallel_sample_test/remote_boot',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        // },
        // {
        //     operateName: '启动单台仪表标液核查',
        //     operateCode: 'CN3083',
        //     operateUrl: '/countercharge/the_liquid_verification/remote_boot',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        // },
        // {
        //     operateName: '启动单台仪表加标回收',
        //     operateCode: 'CN3084',
        //     operateUrl: '/countercharge/standard_addition_recovery/remote_boot',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        //     inputItems: [{
        //         component: CommonSelect,
		// 		label: '加标系数',
        //         field: 'coefficient',
        //         dataType: 'number',
        //         props: {value: null,dataSource: Array.from({length:5}).map((i,index)=>({id: index+1,name: index+1})),placeholder: '请选择', clearable: false, },
        //     },{
        //         component: InputNumber,
		// 		label: '仪表分析时间',
        //         field: 'polanalysismin',
        //         dataType: 'number',
        //         props: {value: null,placeholder: '请输入' },
        //     }]
        // },
        // {
        //     operateName: '启动测量',
        //     operateCode: 'CN3999',
        //     operateUrl: '/countercharge/measurement/start',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        // },
        // {
        //     operateName: '空白测试',
        //     operateCode: 'CN3998',
        //     operateUrl: '/countercharge/test/blank',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        // },
        // {
        //     operateName: '初始化清洗',
        //     operateCode: 'CN3997',
        //     operateUrl: '/countercharge/initial/cleaning',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        // },
        // {
        //     operateName: '停止测试',
        //     operateCode: 'CN3996',
        //     operateUrl: '/countercharge/testing/stop',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        // },
        // {
        //     operateName: '仪器重启',
        //     operateCode: 'CN3995',
        //     operateUrl: '/countercharge/instrument/restart',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        // },
        // {
        //     operateName: '校准',
        //     operateCode: 'CN3994',
        //     operateUrl: '/countercharge/calibration/begin',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        // },
        // {
        //     operateName: '标样1测量',
        //     operateCode: 'CN3993',
        //     operateUrl: '/countercharge/sample_1/measurement',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        // },
        // {
        //     operateName: '标样2测量',
        //     operateCode: 'CN3992',
        //     operateUrl: '/countercharge/sample_2/measurement',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        // },
        // {
        //     operateName: '初始化装液',
        //     operateCode: 'CN3991',
        //     operateUrl: '/countercharge/fluid/initialize',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        // },
        // {
        //     operateName: '余量重置',
        //     operateCode: 'CN3990',
        //     operateUrl: '/countercharge/allowance/reset',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        // },
        // {
        //     operateName: '加标回收',
        //     operateCode: 'CN3989',
        //     operateUrl: '/countercharge/mark/recycle',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        // },
        // {
        //     operateName: '校时',
        //     operateCode: 'CN1999',
        //     operateUrl: '/countercharge/time/calibration',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        //     inputItems: [{
        //         component: DatePicker,
		// 		label: '时间',
        //         field: 'systemtime',
        //         dataType: 'date',
        //         props: {value: '', type: 'datetime', format: 'yyyy-MM-dd HH:mm:ss',placeholder: '请选择时间', clearable: false, confirm: false},
        //     }]
        // },
        // {
        //     operateName: '模式设置',
        //     operateCode: 'CN1998',
        //     operateUrl: '/countercharge/pattern/setting',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        //     inputItems: [{
        //         component: CommonSelect,
		// 		label: '模式',
        //         field: 'runmode',
        //         dataType: 'number',
        //         props: {value: null,dataSource: [{id: 1, name: '连续模式'},{id: 2, name: '周期模式'},{id: 3, name: '定点模式'},{id: 4, name: '受控模式'},{id: 5, name: '手动模式'}],placeholder: '请选择', clearable: false, },
        //     }]
        // },
        // {
        //     operateName: '测量间隔设置',
        //     operateCode: 'CN1997',
        //     operateUrl: '/countercharge/interval/measurement',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        //     inputItems: [{
        //         component: InputNumber,
		// 		label: '时间间隔(分)',
        //         field: 'interval',
        //         dataType: 'number',
        //         props: {value: null, placeholder: '请输入' },
        //     }]
        // },
        // {
        //     operateName: '零点核查间隔设置',
        //     operateCode: 'CN1996',
        //     operateUrl: '/countercharge/interval/zero_check',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        //     inputItems: [{
        //         component: InputNumber,
		// 		label: '时间间隔(分)',
        //         field: 'interval',
        //         dataType: 'number',
        //         props: {value: null, placeholder: '请输入' },
        //     }]
        // },
        // {
        //     operateName: '跨度核查间隔设置',
        //     operateCode: 'CN1995',
        //     operateUrl: '/countercharge/interval/span_check',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        //     inputItems: [{
        //         component: InputNumber,
		// 		label: '时间间隔(分)',
        //         field: 'interval',
        //         dataType: 'number',
        //         props: {value: null, placeholder: '请输入' },
        //     }]
        // },
        // {
        //     operateName: '标样核查间隔设置',
        //     operateCode: 'CN1994',
        //     operateUrl: '/countercharge/interval/sample_check',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        //     inputItems: [{
        //         component: InputNumber,
		// 		label: '时间间隔(分)',
        //         field: 'interval',
        //         dataType: 'number',
        //         props: {value: null, placeholder: '请输入' },
        //     }]
        // },
        // {
        //     operateName: '校准间隔时间',
        //     operateCode: 'CN1993',
        //     operateUrl: '/countercharge/interval/calibration',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        //     inputItems: [{
        //         component: InputNumber,
		// 		label: '时间间隔(时)',
        //         field: 'interval_hour',
        //         dataType: 'number',
        //         props: {value: null, placeholder: '请输入' },
        //     },{
        //         component: InputNumber,
		// 		label: '时间间隔(天)',
        //         field: 'interval_day',
        //         dataType: 'number',
        //         props: {value: null, placeholder: '请输入' },
        //     }]
        // },
        // {
        //     operateName: '清洗周期设置',
        //     operateCode: 'CN1991',
        //     operateUrl: '/countercharge/cleaning_period/setting',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        //     inputItems: [{
        //         component: InputNumber,
		// 		label: '周期(次)',
        //         field: 'cleaning_period',
        //         dataType: 'number',
        //         props: {value: null,placeholder: '请输入' },
        //     }]
        // },
        // {
        //     operateName: '运行模式设置',
        //     operateCode: 'CN1990',
        //     operateUrl: '/countercharge/running_mode/setting',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        //     inputItems: [{
        //         component: CommonSelect,
		// 		label: '运行模式',
        //         field: 'runmode',
        //         dataType: 'number',
        //         props: {value: null,dataSource: [{id: 1, name: '在线'},{id: 2, name: '离线'},{id: 3, name: '维护'}],placeholder: '请选择', clearable: false, },
        //     }]
        // },
        // {
        //     operateName: '自动校准状态设置',
        //     operateCode: 'CN1989',
        //     operateUrl: '/countercharge/state/calibration',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        //     inputItems: [{
        //         component: CommonSelect,
		// 		label: '状态',
        //         field: 'state',
        //         dataType: 'number',
        //         props: {value: null,dataSource: [{id: 1, name: '开启'},{id: 2, name: '关闭'}],placeholder: '请选择', clearable: false, },
        //     }]
        // },
        // {
        //     operateName: '自动清洗状态设置',
        //     operateCode: 'CN1988',
        //     operateUrl: '/countercharge/state/cleanout',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        //     inputItems: [{
        //         component: CommonSelect,
		// 		label: '状态',
        //         field: 'state',
        //         dataType: 'number',
        //         props: {value: null,dataSource: [{id: 1, name: '开启'},{id: 2, name: '关闭'}],placeholder: '请选择', clearable: false, },
        //     }]
        // },
        // {
        //     operateName: '数据补传(仪表传工控机)',
        //     operateCode: 'CN3988',
        //     operateUrl: '/countercharge/data/transfer_ipc',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        //     inputItems: [{
        //         component: DatePicker,
		// 		label: '时间',
        //         field: 'time',
        //         realField: ['begintime','endtime'],
        //         dataType: 'array',
        //         props: {value: [], type: 'daterange', format: 'yyyy-MM-dd',placeholder: '请选择时间', clearable: false, },
        //     }]
        // },
        // {
        //     operateName: '数据补传(工控机传平台)',
        //     operateCode: 'CN3987',
        //     operateUrl: '/countercharge/data/transfer_platform',
        //     operateTime: '',
        //     result: '',
        //     operateMan: '',
        //     inputItems: [{
        //         component: DatePicker,
		// 		label: '时间',
        //         field: 'time',
        //         realField: ['begintime','endtime'],
        //         dataType: 'array',
        //         props: {value: [], type: 'daterange', format: 'yyyy-MM-dd',placeholder: '请选择时间', clearable: false, },
        //     }]
        // },
        
        
    ];
    currentDivisor: any= {}
    columnDefs: ColDefCustom[] = []
    factorset: number = -1
    components: {id: number, name: string}[] = []
    deviceType: Number = 0;
    copy(data) {
        return {
            ...data,
            inputItems: (data.inputItems||[]).map(i=> {
                return {...i, props: JSON.parse(JSON.stringify(i.props))}
            })
        }
    }
    async operate(data: DeviceControlVOI.RowI) {
        let t = this
        let res = await alertControlModal(t.mn, t.copy(data), this.currentDivisor.polid)
        if(res) {
            this.searchNewest([data.operateCode])
        }
    }
    created() {
        this.deviceType = parseInt(this.$route.query.type);
        let t = this
        this.columnDefs = [
            {
                headerName: '操作',
                field: 'operateName',
                minWidth: 120,
                cellRendererFramework: CellRenderTsx,
                cellRendererFrameworkOpt: {
                    cellRender(h, params) {
                        let data: DeviceControlVOI.RowI = params.data;
                        return (
                            <div class="wqms-cursor wqms-link" on-click={t.operate.bind(t, data)}>
                                {data.operateName}
                            </div>
                        );
                    },
                },
            },
            {
                headerName: '最近操作时间',
                field: 'operateTime',
                minWidth: 170,
            },
            {
                headerName: '结果',
                field: 'result',
                minWidth: 100,
            },
            {
                headerName: '结果操作人',
                field: 'operateMan',
                minWidth: 100,
            },
        ];
    }
    async searchNewest(cns?: string[]) {
        if(!cns) {
            cns = [...this.rowDataComponent,...this.rowDataSystem].map(i=> i.operateCode.replace('CN', ''))
        }
        //判断是否添加报警器
        let {code,data} = await DeviceControlApi.buzzerAuthority({mn: this.mn});
        var authority = data['authority'];
        if(authority == 1)
        {
           if(this.rowDataSystem.length != 14){
            this.rowDataSystem.push({
                operateName: '开启蜂鸣器报警',
                operateCode: 'CN3100',
                operateUrl: '/countercharge/on/buzzer',
                operateTime: '',
                result: '',
                operateMan: '',
               });
               this.rowDataSystem.push({
                operateName: '关闭蜂鸣器报警',
                operateCode: 'CN3101',
                operateUrl: '/countercharge/off/buzzer',
                operateTime: '',
                result: '',
                operateMan: '',
               });
           }
        }
        else
        {
            if(this.rowDataSystem.length == 14)
            {
                this.rowDataSystem.pop()
                this.rowDataSystem.pop()
            }
        }
        let {code,data} = await DeviceControlApi.queryNewestRecord({mn: this.mn, cns, polid:this.currentDivisor.polid})
        if(code===0) {
            let map:{[str:string]: DeviceControlDOI.NewestRecordI} = {}
            data.forEach(i=> {
                map['CN'+i.cn] = i
            })
            this.rowDataComponent.forEach(i=> {
                if(map[i.operateCode]) {
                    i.operateTime = DateTimeUtil.formateDate(map[i.operateCode].operation_time*1000)
                    i.result = map[i.operateCode].operating_result
                    i.operateMan = map[i.operateCode].operation_user
                }
                else{
                    i.operateTime = ""
                    i.result = ""
                    i.operateMan = ""
                }
            })
            var aaa = this.rowDataSystem;
            this.rowDataSystem.forEach(i=> {
                if(map[i.operateCode]) {
                    i.operateTime = DateTimeUtil.formateDate(map[i.operateCode].operation_time*1000)
                    i.result = map[i.operateCode].operating_result
                    i.operateMan = map[i.operateCode].operation_user
                }
                else{
                    i.operateTime = ""
                    i.result = ""
                    i.operateMan = ""
                }
            })
            this.gridOptionsSystem.api!.redrawRows();
            this.gridOptionsComponent.api!.redrawRows();
        }
    }
    async mounted() {
        this.mn = this.$route.query.mn;
        this.factorset = +this.$route.query.factorset;
        await this.searchComponent()
        this.searchNewest()
        Bus.$on(Events.StationChange, this.stationChange);
    }
    
    async searchComponent() {
        let {code, data} = await UnitGroupApi.searchRelation(this.factorset)
        if(code === 0) {
            this.components = data.filter(i => 
                !i.name.includes("pH") && !i.name.includes("浊度") && !i.name.includes("电导率")
                && !i.name.includes("溶解氧") && !i.name.includes("温度") && !i.name.includes("pH"))
            .map(i=> ({id: i.component_id,name: i.name, polid: i.polid}))
            this.currentDivisor = this.components[0]
        }
    }
    async stationChange(data: StationListDOI.RowDataI) {
        this.mn = data.mn;
        this.factorset = data.factorset;
        await this.searchComponent()
        this.searchNewest()
    }

    beforeDestroy() {
        Bus.$off(Events.StationChange, this.stationChange);
    }
    operateRecord() {
        alertControlRecordModal(this.mn)
    }
    clickDivisor(data) {
        this.currentDivisor = data
        this.searchNewest();
    }
    render(h) {
        return (
            <div class={bem()}>
                <div class={bem('title')}>
                    系统控制
                    <Button type="primary" on-click={this.operateRecord.bind(this)}>
                        操作记录
                    </Button>
                </div>
                <AgGridVueCustomTsx
                    ref="agSystem"
                    style="flex: 1"
                    gridOptions={this.gridOptionsSystem}
                    columnDefs={this.columnDefs}
                    rowData={this.rowDataSystem}
                    enableServerSideSorting={false}
                    checkBoxShow={false}
                    pageShow={false}
                />
                <div class={bem('title')} v-if={this.deviceType != 2}>
                    组分控制
                    {
                        this.components.map(i=>  <div class={bem('params-btn', {'acitve': this.currentDivisor.id===i.id})} onClick={this.clickDivisor.bind(this, i)}>{i.name}</div>)
                    }
                </div>
                <AgGridVueCustomTsx
                    v-if={this.deviceType != 2}
                    class={createNamespace('mb6')}
                    ref="agComponent"
                    style="flex: 1"
                    gridOptions={this.gridOptionsComponent}
                    columnDefs={this.columnDefs}
                    rowData={this.rowDataComponent}
                    enableServerSideSorting={false}
                    checkBoxShow={false}
                    pageShow={false}
                />
            </div>
        );
    }
}
